/* eslint-disable react-hooks/exhaustive-deps */
import CreateIcon from "@mui/icons-material/Create";
import AddIcon from "@mui/icons-material/Add";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import React, { useEffect, useRef, useState } from "react";
import { Button, Modal, Spinner } from "react-bootstrap";
import ScrollBar from "react-perfect-scrollbar";
import { useSelector } from "react-redux";
import CommentService from "../../../services/CommentService";
import Paginator from "../../components/Paginator/Paginator";
import {
  getErrorMsg,
  showToast,
  useDidUpdateEffect,
} from "../../shared/helpers";
import "./comments.css";

export function Delete(props) {
  const { msg, delfunc } = props;

  const [dis, setdis] = useState(false);

  return (
    <Modal
      show={props.show}
      onHide={props.onHide}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header className="no-border">
        <Modal.Title id="contained-modal-title-vcenter">
          <div className="dialogheader">
            <div className="d-flex">
              <img
                className="iconstyle"
                src={require("../../../assets/icons/attention_light20@3x.png")}
                alt="icon"
              />
              <h5 style={{ fontWeight: "bolder" }}>Warning</h5>
            </div>
            <img
              className="iconstyle crossicon"
              src={require("../../../assets/icons/x_light50@3x.png")}
              alt="icon"
              onClick={!dis && props.onHide}
            />
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="dialogbody">
          <span>{msg}</span>
        </div>
      </Modal.Body>
      <Modal.Footer className="no-border">
        <Button
          disabled={dis}
          variant="light"
          onClick={() => delfunc(setdis)}
          style={{
            color: "#962424",
            background: "transparent",
            border: "none",
          }}
          id="delete"
        >
          Delete
        </Button>
        <Button
          disabled={dis}
          style={{ marginRight: 25 }}
          onClick={props.onHide}
          id="dont_delete"
        >
          Don't Delete
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

function AddComments(props) {
  const [payload, setpayload] = useState({ name: "", remarks: "" });

  const [dis, setdis] = useState(false);

  const add = () => {
    setdis(true);
    CommentService.createComment(payload)
      .then(() => {
        props.update();
        props.onHide();
        showToast("Comment created Successfully", true);
        setdis(false);
        setpayload({ name: "", remarks: "" });
      })
      .catch((err) => {
        setdis(false);
        showToast(getErrorMsg(err) || "Something Went Wrong");
      });
  };

  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header className="no-border">
        <Modal.Title id="contained-modal-title-vcenter">
          <div className="dialogheader">
            <div className="d-flex">
              <img
                className="iconstyle"
                src={require("../../../assets/icons/toolkit_light20@3x.png")}
                alt="icon"
              />
              <h5 style={{ fontWeight: "bolder" }}>Add Comment</h5>
            </div>
            <img
              className="iconstyle crossicon"
              src={require("../../../assets/icons/x_light50@3x.png")}
              alt="icon"
              onClick={props.onHide}
            />
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="dialogbody">
          <div>
            <h4>Comment Name</h4>
            <input
              className="form-control input-field"
              placeholder="Comment Name"
              type="text"
              id="comment_name"
              maxLength="100"
              onChange={(ev) =>
                setpayload({ ...payload, name: ev.target.value })
              }
            />
          </div>
          <div className="dialogtextarea">
            <h4>Additional Remarks</h4>
            <textarea
              id="additional_remarks"
              className="form-control input-field"
              placeholder="Additional Remarks"
              type="text"
              maxLength="5000"
              onChange={(ev) =>
                setpayload({ ...payload, remarks: ev.target.value })
              }
            />
          </div>
          <div className="text-right">
            <small>{payload.remarks?.length ?? 0}/5000</small>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="no-border">
        <Button
          disabled={dis || !payload.name}
          style={{ marginRight: 25 }}
          onClick={add}
          id="save_comment"
        >
          Save Comment
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

function Comments() {
  const commentList = useRef(null);

  const [modalShow, setModalShow] = React.useState(false);
  const [delmodalShow, setdelModalShow] = React.useState(false);

  const [comments, setcomments] = useState({});

  const [page, setpage] = useState(1);

  const [singleComment, setsingleComment] = useState({
    name: "",
    remarks: "",
    id: 0,
    is_visible: false,
  });

  const [loader, setloader] = useState(true);
  const [active, setactive] = useState(0);
  const [update, setupdate] = useState(0);
  const [disedit, setdisedit] = useState(false);

  const searchField = useSelector((state) => state.header.searchField);
  const [skip, setSkip] = useState(false);

  useDidUpdateEffect(() => {
    setSkip(true);
    setloader(true);
    CommentService.getAllComments(searchField, 1)
      .then((x) => {
        setcomments(x.data);
        setpage(1);
      })
      .catch(() => {})
      .finally(() => setloader(false));
  }, [searchField]);

  useEffect(() => {
    if (!skip) {
      setloader(true);
      CommentService.getAllComments("", page)
        .then((x) => {
          setcomments(x.data);
        })
        .catch(() => {})
        .finally(() => setloader(false));
    } else {
      setSkip(false);
    }
  }, [update, page]);

  const setactiv = (index) => {
    setsingleComment({
      ...singleComment,
      name: comments.data[index].name,
      id: comments.data[index].id,
      remarks: comments.data[index].remarks,
      is_visible: comments.data[index].is_visible ?? true,
    });
    setactive(index);
  };

  useEffect(() => {
    if (comments?.data && comments?.data?.length > 0) {
      if (active > comments?.data?.length - 1 || update === 0) {
        setactiv(0);
      } else {
        setactiv(active);
      }
    } else {
      setsingleComment({
        name: "",
        remarks: "",
        id: 0,
        is_visible: true,
      });
    }
    if (commentList?.current) {
      commentList.current.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [comments]);

  const edit = () => {
    setdisedit(true);
    CommentService.updateComment(singleComment.id, {
      name: singleComment.name,
      remarks: singleComment.remarks,
    })
      .then(() => {
        setupdate((prev) => prev + 1);
        showToast("Comment Editted Successfully", true);
      })
      .catch((err) => {
        showToast(getErrorMsg(err) || "Something went wrong");
      })
      .finally(() => setdisedit(false));
  };

  const delcomm = (setdisdel) => {
    setdisdel(true);
    CommentService.DeleteComment(singleComment.id)
      .then(() => {
        setupdate((prev) => prev + 1);
        showToast("Comment Deleted Successfully", true);
      })
      .catch((err) => {
        showToast(getErrorMsg(err) || "Something went wrong");
      })
      .finally(() => {
        setdisdel(false);
        setdelModalShow(false);
      });
  };

  const toggleVisibility = (e, commentId, currentVisibility) => {
    e.stopPropagation();
    const newVisibility = !currentVisibility;
    CommentService.updateCommentVisibility(commentId, newVisibility)
      .then(() => {
        // Optimistically update local list so UI reflects the change immediately
        setcomments((prev) => {
          if (!prev?.data) return prev;
          return {
            ...prev,
            data: prev.data.map((item) =>
              item.id === commentId
                ? { ...item, is_visible: newVisibility }
                : item
            ),
          };
        });
        setupdate((prev) => prev + 1);
        showToast(
          `Comment ${newVisibility ? "made visible" : "hidden"} successfully`,
          true
        );
      })
      .catch((err) => {
        showToast(getErrorMsg(err) || "Something went wrong");
      });
  };

  return (
    <div className="mainbody">
      <div className="leftside">
        <div className="leftside-header d-flex align-items-center justify-content-between">
          <h5 className="mainheading">Comments</h5>
          <button
            onClick={() => setModalShow(true)}
            className="btn btn-primary ml-auto"
            id="add_comment"
          >
            Add Comment <AddIcon />
          </button>
          <AddComments
            show={modalShow}
            onHide={() => setModalShow(false)}
            update={() => setupdate(update + 1)}
          />
          <Delete
            show={delmodalShow}
            onHide={() => setdelModalShow(false)}
            msg={
              "“Are you sure you want to delete this comment?” Deleting will also delete the comment from associated inspections and reports"
            }
            delfunc={delcomm}
          />
        </div>
        <div>
          <ScrollBar>
            <ul
              className={loader ? "ul-style list-spinner" : "ul-style"}
              ref={commentList}
            >
              {loader ? (
                <Spinner animation="border" variant="success" />
              ) : (
                comments?.data?.map((item, i) => (
                  <li
                    key={`comment-${i}`}
                    className={`liststyle${i === active ? " listActive" : ""}`}
                    onClick={() => setactiv(i)}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <span style={{ flex: 1 }}>{item.name}</span>
                    <span
                      onClick={(e) =>
                        toggleVisibility(e, item.id, item.is_visible ?? false)
                      }
                      style={{
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        marginLeft: "8px",
                      }}
                      title={item.is_visible ? "Hide comment" : "Show comment"}
                    >
                      {item.is_visible ? (
                        <VisibilityOutlinedIcon style={{ fontSize: "20px" }} />
                      ) : (
                        <VisibilityOffOutlinedIcon
                          style={{ fontSize: "20px" }}
                        />
                      )}
                    </span>
                  </li>
                ))
              )}
            </ul>
          </ScrollBar>
        </div>
        <div className="mt-0 mb-3">
          <Paginator
            activePage={page}
            itemsCountPerPage={comments?.per_page}
            totalItemsCount={comments?.total ?? 0}
            onChange={(page) => {
              setSkip(false);
              setpage(page);
            }}
          />
        </div>
      </div>
      <ScrollBar
        style={{
          height: "calc(100vh - 90px)",
          overflowY: "auto",
          width: "100%",
          background: "#e7ece8",
          borderTopLeftRadius: "8px",
          borderTopRightRadius: "8px",
        }}
      >
        <div className="rightside" style={{ width: "100%" }}>
          <div className="rightsideinner">
            <div className="float-label">
              <div>
                <input
                  className="input-field form-control"
                  type="text"
                  maxLength="100"
                  id="comment_name"
                  value={singleComment.name}
                  disabled={loader || comments?.data?.length < 1}
                  onChange={(ev) => {
                    setsingleComment({
                      ...singleComment,
                      name: ev.target.value,
                    });
                  }}
                />
              </div>
              <label className="input-field Active" htmlFor="commname">
                Comment Name
              </label>
            </div>
            <div className="float-label" style={{ marginTop: "2%" }}>
              <div>
                <textarea
                  className="input-field form-control"
                  type="text"
                  maxLength="5000"
                  style={{ minHeight: "250px" }}
                  id="remarks"
                  disabled={loader || comments?.data?.length < 1}
                  value={singleComment.remarks ?? ""}
                  onChange={(ev) => {
                    setsingleComment({
                      ...singleComment,
                      remarks: ev.target.value,
                    });
                  }}
                />
              </div>
              <label className="Active input-field" htmlFor="remarks">
                Additional Remarks
              </label>
              <small className="text-right">
                {singleComment.remarks?.length ?? 0}/5000
              </small>
            </div>
            <div className="rightsideactions">
              <button
                className="btn btn-primary delbtn"
                onClick={() => setdelModalShow(true)}
                disabled={loader || comments?.data?.length < 1}
                id="delete_comment"
              >
                Delete Comment
              </button>
              <button
                className="btn btn-primary"
                disabled={
                  disedit ||
                  !singleComment.name ||
                  loader ||
                  comments?.data?.length < 1
                }
                onClick={edit}
                id="edit_comment"
              >
                Edit Comment <CreateIcon />
              </button>
            </div>
          </div>
        </div>
      </ScrollBar>
    </div>
  );
}

export default Comments;
